import { render } from "./Stock.page.vue?vue&type=template&id=17f3fc2f&scoped=true&ts=true"
import script from "./Stock.page.vue?vue&type=script&lang=ts"
export * from "./Stock.page.vue?vue&type=script&lang=ts"

import "./Stock.page.vue?vue&type=style&index=0&id=17f3fc2f&lang=scss&scoped=true"

import exportComponent from "/builds/anisen/datamanagerweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f3fc2f"]])

export default __exports__